export const POST_TREATMENT_CONFIGS = {
  assets: {
    translationPrefix: "collect:qualities.assets.analytics",
    dataKeys: {
      finalCount: "final_total_count",
      discardedCount: "equipment_type_discarded_count",
      nodeDiscardedCount: "node_discarded_count",
      leasingDiscardedCount: "equipment_type_discarded_leasing_count",
      otherDiscardedCount: "equipment_type_discarded_other_count",
    },
    discardedDataKeys: {
      main: "equipment_types_discarded",
      leasing: "equipment_types_discarded_leasing",
      other: "equipment_types_discarded_other",
      nodes: "discarded_nodes",
    },
    itemLabelKey: "equipment_type",
    showAmount: false,
  },
  purchases: {
    translationPrefix: "collect:qualities.purchases.analytics",
    dataKeys: {
      finalCount: "final_total_amount_purchased_it_services",
      finalAmount: "final_total_somme_purchased_it_services",
      discardedCount: "service_it_purchased_discarded_total_count",
      discardedAmount: "service_it_purchased_discarded_total_amount",
      nodeDiscardedCount: "supplier_discarded_count",
      nodeDiscardedAmount: "supplier_discarded_amount",
      leasingDiscardedCount: "category_discarded_contract_count",
      leasingDiscardedAmount: "category_discarded_contract_amount",
      otherDiscardedCount: "category_discarded_other_count",
      otherDiscardedAmount: "category_discarded_other_amount",
    },
    discardedDataKeys: {
      main: "categories_discarded",
      leasing: "categories_discarded_contract",
      other: "categories_discarded_other",
      nodes: "discarded_suppliers",
    },
    itemLabelKey: "category",
    showAmount: true,
  },
  websites: {
    translationPrefix: "collect:qualities.websites.analytics",
    dataKeys: {
      finalCount: "final_total_count",
      discardedCount: "websites_discarded_count",
    },
    discardedDataKeys: {},
    itemLabelKey: "url",
    showAmount: false,
  },
  external_apps: {
    translationPrefix: "collect:qualities.external_apps.analytics",
    dataKeys: {
      finalCount: "final_total_count",
      discardedCount: "external_apps_discarded_count",
      nodeDiscardedCount: "node_discarded_count",
    },
    discardedDataKeys: {
      nodes: "discarded_nodes",
    },
    itemLabelKey: "name",
    showAmount: false,
  },
  datacenter: {
    translationPrefix: "collect:qualities.datacenter.analytics",
    dataKeys: {
      finalCount: "final_total_count",
      discardedCount: "discarded_dc_count",
      validAssetsCount: "valid_assets_count",
      assetsDiscardedCount: "assets_discarded_count",
    },
    discardedDataKeys: {},
    itemLabelKey: "name",
    showAmount: false,
    showInvalidPueDetail: true,
  },
}
